import { ChevronRight } from '@doist/icons/brand';
import { Box, Button, Container, Image, slugifyText, Text } from '@doist/marketist';
import cn from 'clsx';
import { useTranslation } from 'next-i18next';
import css from './relevant-articles-section.module.css';
export default function RelevantArticlesSection() {
  const {
    t
  } = useTranslation('helpcenter');
  const articles = [{
    title: t('relevantArticles.whatsnew.title'),
    description: t('relevantArticles.whatsnew.description'),
    linkTitle: t('relevantArticles.whatsnew.link'),
    image: `${process.env.NEXT_PUBLIC_BASE_URL}/static/help/whats-new.png`,
    href: '/help/articles/whats-new-WV4aRXKsN'
  }, {
    title: t('relevantArticles.gettingStarted.title'),
    description: t('relevantArticles.gettingStarted.description'),
    linkTitle: t('relevantArticles.gettingStarted.link'),
    image: `${process.env.NEXT_PUBLIC_BASE_URL}/static/help/getting-started.png`,
    href: '/help/articles/get-started-with-todoist-OgNNJR'
  }, {
    title: t('relevantArticles.knownissues.title'),
    description: t('relevantArticles.knownissues.description'),
    linkTitle: t('relevantArticles.knownissues.link'),
    image: `${process.env.NEXT_PUBLIC_BASE_URL}/static/help/known-bugs.png`,
    href: '/help/articles/known-issues-d6dyMz9Y'
  }];
  return <Container tag="ul" className={cn(css.relevantArticles, 'mbs-96 md-mbs-128')} data-sentry-element="Container" data-sentry-component="RelevantArticlesSection" data-sentry-source-file="relevant-articles-section.tsx">
            {articles.map(article => <Box tag="li" key={article.title}>
                    <Box className={css.image}>
                        <Image src={article.image} width={200} height={150} alt="" loading="lazy" />
                    </Box>
                    <Box className={css.content}>
                        <Text id={`article-${slugifyText(article.title)}`} className={css.title} size="minor-lg" weight="semibold">
                            {article.title}
                        </Text>
                        <Text size="body-sm" weight="medium" className={css.description}>
                            {article.description}
                        </Text>
                        <Button variant="tertiary" endIcon={ChevronRight} href={article.href} aria-labelledby={`article-${slugifyText(article.title)}-link`}>
                            {article.linkTitle}
                        </Button>
                    </Box>
                </Box>)}
        </Container>;
}